"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.describeLocationsDifference = describeLocationsDifference;
const utils_1 = require("@daytrip/utils");
function describeLocationsDifference(originalData, newData, simpleLocations) {
    const addedContentLocations = newData.contentLocations.filter((cl) => (0, utils_1.isUndefinedOrNull)(originalData.contentLocations.find((ocl) => ocl.locationId === cl.locationId)));
    const removedContentLocations = originalData.contentLocations.filter((ocl) => (0, utils_1.isUndefinedOrNull)(newData.contentLocations.find((cl) => cl.locationId === ocl.locationId)));
    const addedCustomLocations = newData.customLocations.filter((cl) => (0, utils_1.isUndefinedOrNull)(originalData.customLocations.find((ocl) => ocl.title === cl.title)));
    const removedCustomLocations = originalData.customLocations.filter((ocl) => (0, utils_1.isUndefinedOrNull)(newData.customLocations.find((cl) => cl.title === ocl.title)));
    let message = "";
    if (addedContentLocations.length + removedContentLocations.length + addedCustomLocations.length + removedCustomLocations.length >
        0) {
        message += "Order locations have changed:\n";
        if (addedContentLocations.length > 0) {
            message += `Content locations added: ${addedContentLocations
                .map((cl) => {
                const location = simpleLocations?.find((sl) => sl.locationId === cl.locationId);
                return location ? location.name : cl.locationId;
            })
                .join(", ")}\n`;
        }
        if (removedContentLocations.length > 0) {
            message += `Content locations removed: ${removedContentLocations
                .map((cl) => {
                const location = simpleLocations?.find((sl) => sl.locationId === cl.locationId);
                return location ? location.name : cl.locationId;
            })
                .join(", ")}\n`;
        }
        if (addedCustomLocations.length > 0) {
            message += `Custom locations added: ${addedCustomLocations.map((cl) => cl.title).join(", ")}\n`;
        }
        if (removedCustomLocations.length > 0) {
            message += `Custom locations removed: ${removedCustomLocations.map((cl) => cl.title).join(", ")}\n`;
        }
    }
    return message;
}
//# sourceMappingURL=describeLocationsDifference.js.map